import { transformTypeEventResponse } from './transform-type-event';

export const transformRequestTypeEvent = (values: transformTypeEventResponse): RequestReturn => {
  return {
    codice: values?.code || undefined,
    descrizione: values?.description || undefined,
  };
};

interface RequestReturn {
  codice?: string;
  descrizione?: string;
}
